import type { RouteRecordRaw } from 'vue-router';

export default <RouteRecordRaw[]>[
  {
    path: 'home',
    name: 'support-home',
    component: () => import('./views/SupportHome.view.vue'),
  },
];
